import { Position, Toaster, Intent } from "@blueprintjs/core";

const OurToaster = Toaster.create({
    className: "my-toaster",
    position: Position.TOP_CENTER,
});

let timeShow = 2000;

const Toastr = (msg, type) => {
	switch (type) {
		case 'success':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: Intent.SUCCESS, timeout: timeShow, iconName: 'tick'});
		break;
		case 'error':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: Intent.DANGER, timeout: timeShow, iconName: 'warning-sign'});
		break;
		case 'primary':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: Intent.PRIMARY, timeout: timeShow});
		break;
		case 'warning':
			OurToaster.clear();
			OurToaster.show({ message: msg, intent: Intent.WARNING, timeout: timeShow, iconName: 'warning-sign'});
		break;
    case 'thongbao':
			OurToaster.show({ message: msg, intent: Intent.WARNING, timeout: timeShow, iconName: 'warning-sign'});
		break;
    case 'resetclear':
			OurToaster.clear();
		break;
		default:
			OurToaster.clear();
			OurToaster.show({ message: msg, timeout: timeShow});
		break;
	}
}

export default Toastr;



// WEBPACK FOOTER //
// ./src/components/modules/toastr/toastr.jsx